import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { DeadStock, ExpiryBands, SalesAnalytics } from '@/api/reports-extra';

export type AnalyticsPeriod = '7d' | '30d' | '90d' | '180d' | '365d';

export interface DateRange {
  from?: string;
  to?: string;
  [key: string]: string | undefined;
}

export function useSalesAnalytics(period: AnalyticsPeriod, range: DateRange) {
  const hasRange = Boolean(range.from || range.to);

  return useQuery({
    queryKey: ['analytics', 'sales', hasRange ? range : period],
    queryFn: () =>
      api.get<SalesAnalytics>('/api/analytics/sales', hasRange ? range : { period }),
    staleTime: 30_000,
  });
}

export function useDeadStock(days?: number) {
  return useQuery({
    queryKey: ['analytics', 'dead-stock', days],
    queryFn: () => api.get<DeadStock>('/api/analytics/dead-stock', { days }),
    staleTime: 60_000,
  });
}

export function useExpiryBands(windowDays = 90) {
  return useQuery({
    queryKey: ['analytics', 'expiry-bands', windowDays],
    queryFn: () => api.get<ExpiryBands>('/api/analytics/expiry-bands', { days: windowDays }),
    staleTime: 60_000,
  });
}
